export default "__VITE_ASSET__DRZjSPMG__"